//
// Copyright (c) 2020 Astute Global, Inc.
//
// The view to show whether other users are using the current topic.
//

define(["marionette", "./template/topicUsageTemplate.html"], function (
  Marionette,
  TopicUsageTemplate,
) {
  "use strict";

  var TopicUsageView = {};

  TopicUsageView.topicUsageView = Marionette.ItemView.extend({
    template: TopicUsageTemplate,
    className: "topic-usage",
  });

  return TopicUsageView;
});
